export class PackageContent {
    SerieType: string;
    Series: Array<any>;

    constructor() {
        this.SerieType = '';
        this.Series = [];
    }
}